<div class="vacations-container">
  <h3>Vacaciones</h3>
  <p>Configuración de períodos de vacaciones o cierres temporales.</p>
  <p>Location ID: {{ locationId }}</p>
</div>
